module.exports = __webpack_public_path__ + "img/russiancards.ec804dfc.svg";